jQuery( document ).ready(function() 
{
 var found = false
 window.setInterval(function()
 {
  if(!found)
  {
   if(jQuery('.single-product .product-options #r1 label').length )
   {
    if(jQuery('.single-product .product-options #r1 label').size() == 2 )
    {
     if(jQuery('.single-product .product-options #r1 label:nth-of-type(2) input[type="radio"]').length)
     {
      jQuery('.single-product .product-options #r1 label:nth-of-type(2) input[type="radio"]').click();  
     } 
    }
    clearInterval();
    found = true;
   }
  }
 }, 2000);
});







var url = window.location.href;

if(!url.includes('/product') || url.includes('/collection')){
  
  jQuery(document).ready(function(){
  
  var saleBadges = jQuery('.product-badge.sale-badge');
  
  //$('.product-badge.sale-badge img').attr('src', 'https://cdn.shopify.com/s/files/1/2462/4733/files/sale-icon.png?v=1583765792')
  
  for(var i = 0; i < saleBadges.length; i++){
    
    if(saleBadges.eq(i).siblings('.sold-out-badge').length){
      
      saleBadges.eq(i).hide();
    }
    
	var saleImg = saleBadges.eq(i).find('img');
    
    if(!saleImg.attr('src').includes('TopSeller')){
       saleImg.attr('src', 'https://cdn.shopify.com/s/files/1/2462/4733/files/sale-icon.png?v=1583765792')
       }
  }
  });
};

if(url.includes('/product')){


jQuery(document).ready(function(){

  Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
  
  
  function isLight(){
    if(jQuery('#addToCart').hasClass('btn-yellow') || jQuery('#addToCart').hasClass('btn-green')){
      
     return true; 
    }
  }
  

  if(isLight()){
    var atcColor = jQuery('.btn-add-to-cart').css('background-color');
  var tiestaStyle = 'background-color: ' + atcColor + '!important; border: 2px solid ' + atcColor + '!important; color: #323D48!important';
   var tiestaStyle2 = 'background-color: ' + atcColor + '!important; border: 2px solid ' + atcColor + '!important;  color: #323D48!important';

  }
  
  else{
    var atcColor = jQuery('.btn-add-to-cart').css('background-color');
   
     var tiestaStyle = 'background-color: ' + atcColor + '!important; border: 2px solid ' + atcColor + '!important; color: #FFF!important';
   var tiestaStyle2 = 'background-color: ' + atcColor + '!important; border: 2px solid ' + atcColor + '!important;  color: #FFF!important';
  }
  
  
  	jQuery('body').addClass('tiesta-products');
    Element.prototype.appendAfterThis = function(element) {
        element.parentNode.insertBefore(this, element.nextSibling);
    };
    var sticky = document.createElement('div');
    //sticky.innerHTML = '<div class="tiesta-st-container" id="tiesta-st-containerID"> <div class="tiesta-st-container__outer"><div class="tiesta-product-cont"><div style = "color:'+atcColor+'" class="tiesta-product-name"></div><div class="tiesta-product-price"></div></div> <div class="tiesta-st-container__inner"><div class="tiesta-st-item_column__button"><a class="tiesta-st-item__button" style = "'+tiestaStyle+'"rel="nofollow">Add to Cart</a></div></div></div></div>';
    var y = document.getElementsByClassName('site-header');
    if(document.getElementsByClassName('tiesta-st-container').length == 0){
      sticky.appendAfterThis(y[0]);  
    $('.tiesta-product-name').html($('.product-title h1').text());
      
  
    //$('.tiesta-product-price').html($('.prices .price').eq(0).text());


      $('.tiesta-st-item__button').click(function(){
       if(!$('.tiesta-st-item__button').hasClass("tiesta-st-disabled")){

          document.querySelectorAll('#addToCart')[0].click();
         document.querySelectorAll('.tiesta-st-item__button')[0].innerText = 'Adding...';
         
         	setTimeout(function(){ 
				document.querySelectorAll('.tiesta-st-item__button')[0].innerText = 'Add to Cart';
                 

            }, 1500);
          }
        
        else{
          $('html, body').animate({
        		scrollTop: ($('.product-options').offset().top - 100)
        }, 500);
        }


      });



    };


     checkIfDisabled();

    function isVisible(elem){
    var elementTop = elem.offset().top;
    var elementBottom = elementTop + elem.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var mc = window.matchMedia("(min-width: 767px)");
            mc.addListener(slideShow);    

        var elem = document.getElementById("tiesta-st-containerID");      
        function slideShow() {
          $('#chat-widget-container').addClass('tiesta-bottom');
          jQuery('.smile-launcher-frame-container').addClass('tiesta-bottom');
            if (mc.matches) { 
                    elem.style.bottom="0px";

                } else {
               elem.style.bottom="0px";
                }
            }

         function slideHide() {    
            elem.style.bottom="-120px";
                $('#chat-widget-container').removeClass('tiesta-bottom');
           jQuery('.smile-launcher-frame-container').removeClass('tiesta-bottom');
         }

        $(document).scroll(function() {
        var y = $(this).scrollTop();
          if(window.innerWidth > 768){
             if (y > 100 && !isVisible($('#addToCart'))) {
           slideShow();

        } else {

            slideHide();

        }
          }
          else{
       if (y > $('#addToCart').offset().top && !isVisible($('#addToCart'))) {
           slideShow();

        } else {

            slideHide();

        }
          }

    });
      function checkIfDisabled(){
        setTimeout(function(){ 
          $('.tiesta-st-item__button').text($('#addToCart').eq(0).val());
          
          
         if($('#addToCart').hasClass('disabled')){
          $('.tiesta-st-item__button').text($('#addToCart').eq(0).val());

           $('.tiesta-st-item__button').addClass('tiesta-st-disabled');
           
         
           
        }
          
          
          
          
          else{
			$('.tiesta-st-item__button').text($('#addToCart').eq(0).val());
              $('.tiesta-st-item__button').removeClass('tiesta-st-disabled');
          }
    }, 50);

    }

  
  
  
  
  jQuery('.btn-add-to-cart').hover(function(){
      
var atcColor = jQuery('.btn-add-to-cart').css('background-color');
  jQuery('.btn-add-to-cart').attr('style', 'visibility: visible; background-color: ' + atcColor + '!important');
  });
  
  
var formGroup = jQuery('.form-group').eq(0); 
  formGroup.attr('style', 'border-bottom: 1px solid ' + atcColor);
  
var atcColor = jQuery('.btn-add-to-cart').css('background-color');
  jQuery('.btn-add-to-cart').attr('style', 'visibility: visible; background-color: ' + atcColor + '!important');
  jQuery('.btn-add-to-cart').attr('style', 'background-color: ' + atcColor + '!important');
  
 /* 
  var isNot = false;
  if(jQuery('.col-lg-push-1 > p').length && jQuery('.col-lg-push-1 > span').length == 0){
    for(var i = 0; i < jQuery('.col-lg-push-1 > p').length; i++){
      console.log('I' + i);
      var desc = jQuery('.col-lg-push-1 > p').eq(0);
      //formGroup.after(desc);
      isNot = true;
    }
    

  }
  else{
    for(var i = 0; i < jQuery('.col-lg-push-1 > span').length; i++){
      var desc = jQuery('.col-lg-push-1 > span').eq(0);
      //formGroup.after(desc);
      isNot = true;
    }
  }*/
 





  var productName = jQuery('.product-title h2').eq(0).text()

  if(!isLight()){
  
    jQuery('#addToCart').addClass('light-text');
    jQuery('.tiesta-product-name').attr('style', 'color: #fff!important');
  
  }
  
 

var timer = setInterval(function(){
  if(jQuery(".selector-wrapper").length) {
    initTest();
     clearInterval(timer);
  }
}, 50);

  
  function initTest(){
    
    function removeClasses(){
      var s = jQuery('.r label span');
      s.removeClass('tiesta-yellow');
      s.removeClass('tiesta-red');
      s.removeClass('tiesta-blue');
      s.removeClass('tiesta-green');
      s.removeClass('tiesta-purple');
      s.removeClass('tiesta-orange');
      s.removeClass('tiesta-light-green');
      
      
    }
Element.prototype.appendBefore = function(element) {
    element.parentNode.insertBefore(this, element);
};
  var globalctr = 1;
  var dCtr = 1;
    
   
jQuery(".selector-wrapper").each(function(i, e) { // select parent
  jQuery(this).addClass("d" + globalctr);
  jQuery(this).addClass('tiesta-form-container');
  if(jQuery(".d"+ globalctr + " select option").length > 0){
    jQuery("<div ></div>")
    	.attr('id', "r" + globalctr)   
     	.attr('class', "r" )
        .insertAfter(this);
  
  var select =jQuery(".d"+ globalctr + " select");
  var option1 = jQuery(".d"+ globalctr + " select option").eq(1).val();
  
	jQuery(".d"+globalctr+" select option").each(function(i, e) {
      
      var dataavail = jQuery('#product-select option[data-value="'+jQuery(this).val()+'"]').data('avail');
      var data_value = jQuery(this).val();
      var data_value_split = data_value.split("-");
      var data_value_trim = data_value_split[0].trim().toLowerCase();
      
	  jQuery("<input type='radio'/><span></span>")
        .attr("value",data_value)
      .attr("checked", i == 0)
   		 .attr("data-id", globalctr)
         .attr("data-avail", dataavail)
         .attr("data-select",data_value_trim)
    	  .html('<p>'+jQuery(this).html()+'</p>')
        .click(function () {
        
              var radioBut = jQuery("#r"+ jQuery(this).attr("data-id")+" input");
              for(var i = 0; i < radioBut.length; i++){
                radioBut[i].checked = false;
                 
              }
        
				var radioBut = jQuery("#r"+ jQuery(this).attr("data-id")+" input");
              for(var i = 0; i < radioBut.length; i++){
                radioBut[i].checked = false;
                 
              }
        
            jQuery(this).prop('checked', true);
        	jQuery(".d"+ jQuery(this).attr("data-id")+" select").focus();
            jQuery(".d"+ jQuery(this).attr("data-id")+" select").val(jQuery(this).val());
  		    jQuery(".d"+ jQuery(this).attr("data-id")+" select").trigger("change");
        
        	
            jQuery('.r span').attr('style', '');
        	var s = jQuery(this).parent().find('span');
            var atcColor = jQuery('.btn-add-to-cart').css('background-color');
        	removeClasses();
        
             if(jQuery('#addToCart').hasClass('btn-yellow')){
               
              s.addClass('tiesta-yellow');
            }

          if(jQuery('#addToCart').hasClass('btn-blue')){
              s.addClass('tiesta-blue');
            }

          if(jQuery('#addToCart').hasClass('btn-red')){

              s.addClass('tiesta-red');
            }

          if(jQuery('#addToCart').hasClass('btn-purple')){
              s.addClass('tiesta-purple');
            }


          if(jQuery('#addToCart').hasClass('btn-green')){
              s.addClass('tiesta-green');
            }

            if(jQuery('#addToCart').hasClass('btn-orange')){
              s.addClass('tiesta-orange');
            }
        
        if(jQuery('#addToCart').hasClass('btn-purple')){
              s.addClass('tiesta-purple');
            }
        	if(jQuery('#addToCart').hasClass('btn-light-green')){
              s.addClass('tiesta-light-green');
            }
        
        	checkIfDisabled();

	
        
        	//jQuery("#r"+ jQuery(this).attr("data-id")+" input").prop('checked', 'false');
        
            
        	
     
        })
       
      .mouseover(function(){
        	var s = jQuery(this).parent().find('span');
            var atcColor = jQuery('.btn-add-to-cart').css('background-color');
            s.attr('style', tiestaStyle2);
      })
      .mouseout(function(){
        
        jQuery(this).parent().find('span').attr('style', '');
        
      })
        .appendTo("#r"+globalctr).parent();
      
		}); 
  
      jQuery("#r"+globalctr+" input").each(function(i, e) {
       
        if(jQuery(this).val().toLowerCase().includes('tin')){
        }
        
        if(i != 0){
          jQuery(this).next('span').addBack().wrapAll('<label style="display:inline-block!important;"></label>');
        }
       else{
          jQuery(this).next('span').addBack().wrapAll('<label style="display:none!important;"></label>');
       }
        
        });
  
    globalctr++;
}
  else{
    jQuery(this).attr('id', "");
     jQuery(this).removeClass('tiesta-form-container');
  }
});
    
 /* 
 jQuery("#r1 input").each(function(i, e) 
 {
  if(jQuery(this).val().toLowerCase().includes('tin -'))
  {
   jQuery(this).click();
   if(jQuery('#addToCart').length)
   {
    setTimeout(function() 
    {
     if(jQuery('#addToCart').val()=='Sold Out')
     {
      jQuery("#r1 input").each(function(i, e) 
      { 
       if(jQuery(this).val().toLowerCase().includes('pouch -'))
       {
        jQuery(this).click();
       } 
      });
     }
    }, 1000);
   }
  }
 });
 */

    

 if(jQuery('#r1 input[data-select="tin"]').length) 
 {
  // jQuery('#r1 input[data-select="tin"]').click();
  if(jQuery('#addToCart').length)
  {
   setTimeout(function() 
   {
    if(jQuery('#addToCart').val()=='Sold Out')
    {
     if(jQuery('.klaviyo-bis-trigger').length)
     {
      jQuery('.klaviyo-bis-trigger').attr('style', 'display:none');
     }
     
     if(jQuery('#r1 input[data-select="pouch"]').length) 
     {
      // jQuery('#r1 input[data-select="pouch"]').click();
      if(jQuery('#addToCart').length)
      {
       setTimeout(function() 
       {
        if(jQuery('#addToCart').val()=='Sold Out')
        {
         if(jQuery('.klaviyo-bis-trigger').length)
         {
          jQuery('.klaviyo-bis-trigger').attr('style', 'display:block');
         }

         var found = false
         var wcInterval = setInterval(wcUpdateNotifyMeInterval, 1000);
         function wcUpdateNotifyMeInterval() 
         {
          console.log('* wcUpdateNotifyMeInterval1 *');
          if(!found)
          {
           console.log('* wcUpdateNotifyMeInterval2 *');
           if(jQuery('#klaviyo-bis-iframe').length)
           {
            console.log('* wcUpdateNotifyMeInterval3 *');
            jQuery('#klaviyo-bis-iframe').contents().find("#variants option:contains(Pouch)").attr('selected',true);
            clearInterval(wcInterval);
            found = true;
           }
          }
         }

         if(jQuery('#r1 input[data-avail="1"]').length) 
         {
          jQuery('#r1 input[data-avail="1"]').click();
         }
         else
         {
          jQuery('#r1 input[data-avail="0"]').click();
         }
        }
       }, 1000);
      }
     }
    }
   }, 1000);
        }
      } else if(jQuery('#r1 input[data-select="pouch"]').length) {
        //jQuery('#r1 input[data-select="pouch"]').click();
      } else {
        // jQuery('#r1 input').eq(1).click();
      }
 jQuery("#r2 input").each(function(i, e) 
 {
  if(jQuery(this).val().toLowerCase().includes('tin'))
  {
   jQuery(this).click();
   if(jQuery('#addToCart').length)
   {
    setTimeout(function() 
    {
     if(jQuery('#addToCart').val()=='Sold Out')
     {
      jQuery("#r1 input").each(function(i, e) 
      { 
       if(jQuery(this).val().toLowerCase().includes('pouch -'))
       {
        jQuery(this).click();
       } 
      });
     }
    }, 1000);
   }
  }
 });


 jQuery("#r1 input").each(function(i, e) 
 {
  if(jQuery(this).val().toLowerCase().includes('tin -'))
  {
   //jQuery(this).click();
   
  }
 });

 


 if(jQuery('.r label').length > 1)
 {
  jQuery('.r').before(jQuery("<span class='tiesta-label'>Size</span>"));
 };
};  
  
 
 
  
var imgSrcs = ['https://cdn.shopify.com/s/files/1/2462/4733/files/tiestatea_secure.png?v=1583304698', 'https://cdn.shopify.com/s/files/1/2462/4733/files/tiestatea_give.png?v=1583304699'];
var badgeTexts = ['Secure Checkout','Support Small Business'];

var container = document.createElement('div');
container.className = 'tiesta-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'tiesta-img-container';
var y = document.getElementsByClassName('form-group')[0];

if(document.getElementsByClassName('tiesta-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}

    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="tiesta-badge-container"><img src="' + imgSrcs[i] +  '"><a class="badge' + i+ '" >'+badgeTexts[i]+'</a></div>';
    imgContainer.appendChild(img);
    img.className = "tiesta-badges-container";
           
    
}   
  
});
};
$( document ).ready(function() {
  $('.about_reviews_block').flickity();
});


//  07-05-2022
$(document).ready(function(){
  setTimeout(function(){
  	$('.cartbutton').removeClass('bold_hidden').show();
	$('.cartbutton.bold_clone').remove(); 
  },1500);
	
}) 

$(document).ready(function(){
       $(".single-acco h3").click(function(){
        // self clicking close
        if($(this).next(".accodion-body").hasClass("active")){
          $(this).next(".accodion-body").removeClass("active").slideUp();
          $(this).children("span").html('+');		
        }
        else{
          $(".accodion-body").removeClass("active").slideUp();
          $(".single-acco h3 span").html('+');
          $(this).next(".accodion-body").addClass("active").slideDown();
          $(this).children("span").html('-');
        }
      }); }) 

      $(document).ready(function(){
  $('#show_seller_instruction').change(function(){
    if($(this).is(':checked')){
      $('.custom_seller_instructions_container').show();
      $('.show_instruction_label .custom_check_icon').show();
      $(this).addClass('checked');
    } else {
      $('.custom_seller_instructions_container').hide();
      $('.show_instruction_label .custom_check_icon').hide();
      $(this).removeClass('checked');
    }
  });
});

